import React, { useState } from 'react'
import { AiFillFileText } from 'react-icons/ai'
import { FiUploadCloud } from 'react-icons/fi'
import QuizHeader from '../../Components/QuizHeader'
import styles from "./Styles/UploadLayout.module.css"
import Button from "../../Components/Button"
import { useNavigate } from 'react-router-dom'
import {MdClose} from "react-icons/md"

export default function UploadLayout() {
  const navigate = useNavigate()
  const [files, setFiles] = useState(['PDF',"CAD","PNG"])
  return (
    <React.Fragment>
    <QuizHeader step6 />
    <div className={styles.container}>
         <header>
          <h2>Upload your layout </h2>
          <h3>Please upload your layout below</h3>
        </header>


        <div className={styles.card}>
        <div className={styles.fileUploadWrapper} data-text="Select your file!">
                <div>
                    <FiUploadCloud color="#161C45" size={60} />
                    <p>Drag and drop files or <span>Browse</span></p>
                    <small>Supported formates: CAD/ PDF/ JPEG/ PNG <br />Max File Size: 5MB</small>
                </div>
                <input name="file-upload-field" type="file" value="" />
          </div>
          
        {/* <h3>Uploading 3/3</h3>
        <div className={styles.uploadedFiles}>
          {files.length !== 0 && files.map((f,index) => {
            return <div>
            <p>{index}.{f}</p>
            <span className={styles.closeIcon}>
            <MdClose size={12} color="#fff" />
            </span>
          </div>
          })}
        </div> */}

        </div>

        <div style={{display:'flex',justifyContent:'center'}}>
            <Button height={56} width={320} onClickHandler={()=>navigate('/dashboard')} radius={10} mt={32} title="Submit" />
        </div>
    </div>
  </React.Fragment>
  )
}
